import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle']

  connect() {
    const saved = localStorage.getItem('theme')
    if (saved) {
      document.documentElement.setAttribute('data-theme', saved)
      this.toggleTarget.checked = saved === 'business'
    }
  }

  change() {
    const theme = this.toggleTarget.checked ? 'business' : 'corporate'
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)
  }
}
